import styled from '@emotion/styled';
import { AdAnalyticsVideoIndexWatchingRating } from '@kaizenplatform/hugot-entity';
import { List } from 'immutable';
import { createElement, FC, useEffect, useState } from 'react';
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis } from 'recharts';

import Language from '../../../entity/Language';

type Props = {
  watchingRatings: List<AdAnalyticsVideoIndexWatchingRating>;
  language: Language;
  className?: string;
};

const WatchingRate: FC<Props> = ({
  watchingRatings,
  language,
  className,
}: {
  watchingRatings: List<AdAnalyticsVideoIndexWatchingRating>;
  language: Language;
  className?: string;
}) => {
  const [watchingRateData, updateWatchingRateData] = useState([]);
  const rateLabel = language === 'ja-JP' ? '視聴率' : 'Ratings';
  useEffect(() => {
    const watchingRateDataNextState: any = [
      {
        name: '0%',
        '再生 / %': 0,
        [rateLabel]: 100,
      },
    ];
    watchingRatings.map((watchingRate) => {
      watchingRateDataNextState.push({
        name: `${watchingRate.until}%`,
        '再生 / %': watchingRate.until,
        [rateLabel]: `${Math.round(watchingRate.rate * 10000) / 100}`,
      });
    });

    updateWatchingRateData(watchingRateDataNextState);
    // TODO: Implementation before introducing rules
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Root className={className}>
      <ResponsiveContainer width="100%" height={200}>
        <LineChart data={watchingRateData}>
          <XAxis dataKey="name" domain={[0, 100]} />
          <CartesianGrid strokeDasharray="3 3" />
          <Tooltip />
          <Legend />
          <Line type="monotone" dataKey={rateLabel} stroke="#82ca9d" unit="%" />
        </LineChart>
      </ResponsiveContainer>
    </Root>
  );
};

const Root = styled('div')({});

export default WatchingRate;
